/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var spine_options_pb = require('../../../spine/options_pb.js');
var google_protobuf_any_pb = require('google-protobuf/google/protobuf/any_pb.js');
var spine_base_field_path_pb = require('../../../spine/base/field_path_pb.js');
goog.exportSymbol('proto.spine.server.model.HandlerId', null, global);
goog.exportSymbol('proto.spine.server.model.HandlerTypeInfo', null, global);
goog.exportSymbol('proto.spine.server.model.MessageFilter', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.server.model.HandlerId = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.server.model.HandlerId, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.server.model.HandlerId.displayName = 'proto.spine.server.model.HandlerId';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.server.model.HandlerId.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.server.model.HandlerId.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.server.model.HandlerId} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.server.model.HandlerId.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: (f = msg.getType()) && proto.spine.server.model.HandlerTypeInfo.toObject(includeInstance, f),
    filter: (f = msg.getFilter()) && proto.spine.server.model.MessageFilter.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.server.model.HandlerId}
 */
proto.spine.server.model.HandlerId.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.server.model.HandlerId;
  return proto.spine.server.model.HandlerId.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.server.model.HandlerId} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.server.model.HandlerId}
 */
proto.spine.server.model.HandlerId.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.spine.server.model.HandlerTypeInfo;
      reader.readMessage(value,proto.spine.server.model.HandlerTypeInfo.deserializeBinaryFromReader);
      msg.setType(value);
      break;
    case 2:
      var value = new proto.spine.server.model.MessageFilter;
      reader.readMessage(value,proto.spine.server.model.MessageFilter.deserializeBinaryFromReader);
      msg.setFilter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.server.model.HandlerId.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.server.model.HandlerId.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.server.model.HandlerId} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.server.model.HandlerId.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.spine.server.model.HandlerTypeInfo.serializeBinaryToWriter
    );
  }
  f = message.getFilter();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.spine.server.model.MessageFilter.serializeBinaryToWriter
    );
  }
};


/**
 * optional HandlerTypeInfo type = 1;
 * @return {?proto.spine.server.model.HandlerTypeInfo}
 */
proto.spine.server.model.HandlerId.prototype.getType = function() {
  return /** @type{?proto.spine.server.model.HandlerTypeInfo} */ (
    jspb.Message.getWrapperField(this, proto.spine.server.model.HandlerTypeInfo, 1));
};


/** @param {?proto.spine.server.model.HandlerTypeInfo|undefined} value */
proto.spine.server.model.HandlerId.prototype.setType = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.server.model.HandlerId.prototype.clearType = function() {
  this.setType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.server.model.HandlerId.prototype.hasType = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional MessageFilter filter = 2;
 * @return {?proto.spine.server.model.MessageFilter}
 */
proto.spine.server.model.HandlerId.prototype.getFilter = function() {
  return /** @type{?proto.spine.server.model.MessageFilter} */ (
    jspb.Message.getWrapperField(this, proto.spine.server.model.MessageFilter, 2));
};


/** @param {?proto.spine.server.model.MessageFilter|undefined} value */
proto.spine.server.model.HandlerId.prototype.setFilter = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.spine.server.model.HandlerId.prototype.clearFilter = function() {
  this.setFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.server.model.HandlerId.prototype.hasFilter = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.server.model.HandlerTypeInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.server.model.HandlerTypeInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.server.model.HandlerTypeInfo.displayName = 'proto.spine.server.model.HandlerTypeInfo';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.server.model.HandlerTypeInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.server.model.HandlerTypeInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.server.model.HandlerTypeInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.server.model.HandlerTypeInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    messageType: jspb.Message.getFieldWithDefault(msg, 1, ""),
    originType: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.server.model.HandlerTypeInfo}
 */
proto.spine.server.model.HandlerTypeInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.server.model.HandlerTypeInfo;
  return proto.spine.server.model.HandlerTypeInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.server.model.HandlerTypeInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.server.model.HandlerTypeInfo}
 */
proto.spine.server.model.HandlerTypeInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessageType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOriginType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.server.model.HandlerTypeInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.server.model.HandlerTypeInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.server.model.HandlerTypeInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.server.model.HandlerTypeInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessageType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOriginType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string message_type = 1;
 * @return {string}
 */
proto.spine.server.model.HandlerTypeInfo.prototype.getMessageType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.spine.server.model.HandlerTypeInfo.prototype.setMessageType = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string origin_type = 2;
 * @return {string}
 */
proto.spine.server.model.HandlerTypeInfo.prototype.getOriginType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.spine.server.model.HandlerTypeInfo.prototype.setOriginType = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.server.model.MessageFilter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.server.model.MessageFilter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.server.model.MessageFilter.displayName = 'proto.spine.server.model.MessageFilter';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.server.model.MessageFilter.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.server.model.MessageFilter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.server.model.MessageFilter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.server.model.MessageFilter.toObject = function(includeInstance, msg) {
  var f, obj = {
    field: (f = msg.getField()) && spine_base_field_path_pb.FieldPath.toObject(includeInstance, f),
    value: (f = msg.getValue()) && google_protobuf_any_pb.Any.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.server.model.MessageFilter}
 */
proto.spine.server.model.MessageFilter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.server.model.MessageFilter;
  return proto.spine.server.model.MessageFilter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.server.model.MessageFilter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.server.model.MessageFilter}
 */
proto.spine.server.model.MessageFilter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new spine_base_field_path_pb.FieldPath;
      reader.readMessage(value,spine_base_field_path_pb.FieldPath.deserializeBinaryFromReader);
      msg.setField(value);
      break;
    case 2:
      var value = new google_protobuf_any_pb.Any;
      reader.readMessage(value,google_protobuf_any_pb.Any.deserializeBinaryFromReader);
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.server.model.MessageFilter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.server.model.MessageFilter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.server.model.MessageFilter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.server.model.MessageFilter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getField();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      spine_base_field_path_pb.FieldPath.serializeBinaryToWriter
    );
  }
  f = message.getValue();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_any_pb.Any.serializeBinaryToWriter
    );
  }
};


/**
 * optional spine.base.FieldPath field = 1;
 * @return {?proto.spine.base.FieldPath}
 */
proto.spine.server.model.MessageFilter.prototype.getField = function() {
  return /** @type{?proto.spine.base.FieldPath} */ (
    jspb.Message.getWrapperField(this, spine_base_field_path_pb.FieldPath, 1));
};


/** @param {?proto.spine.base.FieldPath|undefined} value */
proto.spine.server.model.MessageFilter.prototype.setField = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.server.model.MessageFilter.prototype.clearField = function() {
  this.setField(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.server.model.MessageFilter.prototype.hasField = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Any value = 2;
 * @return {?proto.google.protobuf.Any}
 */
proto.spine.server.model.MessageFilter.prototype.getValue = function() {
  return /** @type{?proto.google.protobuf.Any} */ (
    jspb.Message.getWrapperField(this, google_protobuf_any_pb.Any, 2));
};


/** @param {?proto.google.protobuf.Any|undefined} value */
proto.spine.server.model.MessageFilter.prototype.setValue = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.spine.server.model.MessageFilter.prototype.clearValue = function() {
  this.setValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.server.model.MessageFilter.prototype.hasValue = function() {
  return jspb.Message.getField(this, 2) != null;
};


goog.object.extend(exports, proto.spine.server.model);

// The code for parsing the Protobuf messages of this file from the JSON data.

let known_type_parsers = require('../../../known_type_parsers.js');

proto.spine.server.model.HandlerId.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.server.model.HandlerId.fromObject(jsObject);
};

proto.spine.server.model.HandlerId.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.server.model.HandlerId();
  
  if (obj.type !== undefined) {
    if (obj.type === null) {
      msg.setType(null);
    } else {
      let value = proto.spine.server.model.HandlerTypeInfo.fromObject(obj.type);
      msg.setType(value);
    }
  }
  
  if (obj.filter !== undefined) {
    if (obj.filter === null) {
      msg.setFilter(null);
    } else {
      let value = proto.spine.server.model.MessageFilter.fromObject(obj.filter);
      msg.setFilter(value);
    }
  }
  return msg;
};

proto.spine.server.model.HandlerTypeInfo.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.server.model.HandlerTypeInfo.fromObject(jsObject);
};

proto.spine.server.model.HandlerTypeInfo.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.server.model.HandlerTypeInfo();
  
  if (obj.messageType !== undefined) {
    if (obj.messageType !== null) {
      let value = obj.messageType;
      msg.setMessageType(value);
    }
  }
  
  if (obj.originType !== undefined) {
    if (obj.originType !== null) {
      let value = obj.originType;
      msg.setOriginType(value);
    }
  }
  return msg;
};

proto.spine.server.model.MessageFilter.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.server.model.MessageFilter.fromObject(jsObject);
};

proto.spine.server.model.MessageFilter.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.server.model.MessageFilter();
  
  if (obj.field !== undefined) {
    if (obj.field === null) {
      msg.setField(null);
    } else {
      let value = proto.spine.base.FieldPath.fromObject(obj.field);
      msg.setField(value);
    }
  }
  
  if (obj.value !== undefined) {
    if (obj.value === null) {
      msg.setValue(null);
    } else {
      let parser = known_type_parsers.parsers.get('type.googleapis.com/google.protobuf.Any');
      let value = parser.parse(obj.value);
      msg.setValue(value);
    }
  }
  return msg;
};
